import React, { useContext, useEffect, useState } from 'react';
import "./style.css";

import { Breadcrumb } from "../../Components/Atoms";
import { VehiclesList } from '../../Components/Organisms';

import { ClientPicker, VehicleMap } from '../../Components/Molecules';
import { Button } from '@chakra-ui/react';
import { AddIcon } from '../../Assets/images/svgs';
import PATHS from "../../Routes/paths";
import { useNavigate } from 'react-router-dom';
import { getGeofencesByClient, getVehiclesInfo } from '../../APIs';
import { StoreContext } from '../../Library/contexts';
import { Loader } from "../../Pages";

const ViewVehicles = () => {
  const navigate = useNavigate();

  const { filters, constants } = useContext(StoreContext);

  const [ vehicles, setVehicles ] = useState([]);
  const [ vids, setVids ] = useState([]);
  const [ showLoading, setShowLoading ] = useState(true);
  const [ vehicleMap, setVehicleMap ] = useState(new Map());

  const [ allGeofences, setAllGeofences ] = useState([ ]);

  const breadcrumbPaths = [
    { idx: 1, name: "Lease", link: PATHS.LEASE },
    { idx: 2, name: "Vehicles", isCurrentPage: true },
  ];

  const fetchVehicles = (clientId) => {
    setShowLoading(true);

    getVehiclesInfo(clientId, null, (err, resp) => {
      if (err) {
        console.error(err);
      } else {
        setVehicles(resp);
        setVids(resp.map((veh) => veh.idx));
        resp.forEach(vehicle => {
          vehicleMap.set(vehicle.idx, vehicle);
        })
        setVehicleMap(vehicleMap)
      }
      setShowLoading(false);
    });
  };

  useEffect(() => {
    fetchVehicles(filters.client);
  }, [ filters.client ]);

  const fetchClientGeofences = async (clientId) => {
    try {
      const geoFences = await getGeofencesByClient(clientId);
      setAllGeofences(geoFences);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (filters.client && !allGeofences.length) {
      fetchClientGeofences(filters.client);
    }

  }, [ filters.client ])

  return (
    <>
      {!showLoading ?
        <div className='panel-main view-vehicles'>
          <header>
            <Breadcrumb paths={breadcrumbPaths} />
            <ClientPicker />
          </header>
          <div className="vehicles-cont">
            <div className="geofence-buttons">
              {!allGeofences.length ? <Button onClick={() => navigate(PATHS.ADD_GEOFENCE)} className="lease-vehicle geofence">
                <AddIcon />
                Add geofence
              </Button> : null}
              <Button onClick={() => navigate(PATHS.VIEW_GEOFENCES)} className="view-drivers">
                View Geofences
              </Button>
            </div>
            <div className="vehicles-map">
              { (vids && vids.length) ? <VehicleMap allGeofences={allGeofences} vids={vids} vehMap={vehicleMap} /> : <p className="no-vehicles">No vehicles <br /> available</p>}
            </div>

            <div className="vehicle-table-container">
              <div className="vehicles-button-row">
                <Button onClick={() => navigate(PATHS.LEASE_VEHICLES)} className="lease-vehicle">
                  <AddIcon />
                    Lease vehicles
                    {(filters.client && constants.clientMap[filters.client] && constants.clientMap[filters.client].cName) ?
                      ` to ${constants.clientMap[filters.client].cName}` : ""}
                </Button>
                <Button onClick={() => navigate(`${PATHS.LEASE}/${PATHS.DRIVERS}`)} className="view-drivers">
                  View drivers list
                </Button>
              </div>
                <VehiclesList allVehicles={vehicles} />
            </div>
          </div>
        </div>
      : <Loader hide={true} />}
    </>
  )
}

export default ViewVehicles
